import script from "./TemperatureScale.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemperatureScale.vue?vue&type=script&setup=true&lang=ts"

import "./TemperatureScale.vue?vue&type=style&index=0&id=7bde5992&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bde5992"]])

export default __exports__